import React, { useState } from "react";
import { Card, Row, Col, Typography, Checkbox } from "antd";
import ApartmentImg from "./../../assets/ApartmentImg.png";
import PlotImg from "./../../assets/PlotImg.png";
import VillaImg from "./../../assets/VillaImg.png";
import OfficeImg from "./../../assets/OfficeImg.png";
import ShopImg from "./../../assets/ShopImg.png";

const { Text } = Typography;

function LeadCard({
  id,
  name,
  place,
  rating,
  price,
  currentRate,
  onClick,
  isSelected,
  checked,
  onCheck,
  showCheckbox = false,
  subCategoryName,
}) {
  // const [isSelected, setIsSelected] = useState(false);
  const [isCheckboxHover, setIsCheckboxHover] = useState(false);

  const handleClick = () => {
    // setIsSelected(!isSelected);
    if (onClick) onClick();
  };

  // rating = "4/5"
  const [purchased, total] = (rating || "0/0").split("/").map(Number);
  const remaining = total - purchased; // green bar count

  const subcategoryImages = {
    plot: PlotImg,
    apartment: ApartmentImg,
    villa: VillaImg,
    shop: ShopImg,
    office: OfficeImg,
    default: ApartmentImg,
  };

  const leadImage =
    subcategoryImages[subCategoryName?.toLowerCase()] ||
    subcategoryImages.default;

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "flex-start",
          gap: "8px",
          marginBottom: "4px",
          width: "100%",
        }}
      >
        {/* CHECKBOX */}
        {showCheckbox && (
          <Checkbox
            checked={checked}
            onClick={(e) => e.stopPropagation()}
            onChange={(e) => onCheck(id, e.target.checked)}
            onMouseEnter={() => setIsCheckboxHover(true)}
            onMouseLeave={() => setIsCheckboxHover(false)}
            style={{ marginTop: "18px" }}
          />
        )}

        <Card
          hoverable
          bordered={false}
          onClick={handleClick}
          style={{
            flex: 1,
            width: "100%",
            marginBottom: 10,
            borderRadius: 8,
            background:
              isCheckboxHover || checked
                ? "#f0f6ff"
                : isSelected
                  ? "transparent"
                  : "#fff",
            borderBottom: `2px solid ${isSelected ? "#007bff" : "#DBEAFF"}`,
            transition: "all 0.3s ease",
            padding: "4px",
          }}
          styles={{
            body: { padding: 0 },
          }}
        >
          <Row align="middle">
            <Col flex="60px">
              <img
                src={leadImage}
                alt={name}
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: 7,
                }}
              />
            </Col>

            <Col flex="auto">
              <Row>
                {/* LEFT */}
                <Col flex="auto">
                  <Text strong style={{ fontSize: 14 }}>
                    {name}
                  </Text>
                  <br />
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    <span
                      style={{
                        width: "6px",
                        height: "6px",
                        borderRadius: "50%",
                        backgroundColor: "#3fc974",
                        display: "inline-block",
                      }}
                    />
                    <Text type="secondary" style={{ fontSize: 12 }}>
                      {place}
                    </Text>
                  </div>
                </Col>

                {/* Divider */}
                <div
                  style={{
                    width: "2px",
                    minHeight: "32px",
                    backgroundColor: "#fff",
                    marginRight: "8px",
                    alignSelf: "center",
                  }}
                />

                {/* RIGHT */}
                <Col>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                    }}
                  >
                    {/* BARS: green = remaining, gray = purchased */}
                    <div style={{ display: "flex", gap: "1px" }}>
                      {Array.from({ length: total }).map((_, index) => (
                        <div
                          key={index}
                          style={{
                            width: "3px",
                            height: "12px",
                            borderRadius: "2px",
                            backgroundColor:
                              index < remaining ? "green" : "#ccc",
                          }}
                        />
                      ))}
                    </div>

                    <Text style={{ fontSize: 13 }}>
                      {total - remaining}/{total} left
                    </Text>
                  </div>

                  <Text strong style={{ fontSize: 13, color: "#007bff" }}>
                    ₹{currentRate}
                  </Text>
                </Col>
              </Row>
            </Col>
          </Row>
        </Card>
      </div>
    </>
  );
}

export default LeadCard;
